import { useLocation } from "react-router-dom";

// 欄目頁：/news(含 /news/:id)、/chart(含 /chart/:chartType)、/waroom、/institute
// 聲明(/declaration)、登入、註冊、個人中心、404 都不在名單裡，自動不顯示
const SECTIONS = ["/news", "/chart", "/waroom", "/institute"];

export default function useShowHotTopics() {
  const { pathname } = useLocation();
  return (
    pathname === "/" ||
    SECTIONS.some((p) => pathname === p || pathname.startsWith(p + "/"))
  );
}